module.exports = __webpack_public_path__ + "img/发布工程询价icon@2x.a4a71f7a.png";